import { render, staticRenderFns } from "./demote-manager.vue?vue&type=template&id=0e16dc5b"
import script from "./demote-manager.vue?vue&type=script&lang=js"
export * from "./demote-manager.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports